import {
  useContext,
  createContext,
  useState,
  type Dispatch,
  type SetStateAction,
  type PropsWithChildren,
} from 'react';

/**
 * パスワードフォームを表示するかどうか（初回リクエストが 401 で失敗した場合）の state
 */
const shouldShowPasswordFormContext = createContext<boolean>(false);
const setShouldShowPasswordFormContext = createContext<
  Dispatch<SetStateAction<boolean>>
>(() => undefined);

export function ShouldShowPasswordFormContext({
  children,
  initialValue,
}: PropsWithChildren<{readonly initialValue?: boolean}>) {
  const [shouldShowPasswordForm, setShouldShowPasswordForm] = useState<boolean>(
    initialValue ?? false,
  );

  return (
    <shouldShowPasswordFormContext.Provider value={shouldShowPasswordForm}>
      <setShouldShowPasswordFormContext.Provider
        value={setShouldShowPasswordForm}
      >
        {children}
      </setShouldShowPasswordFormContext.Provider>
    </shouldShowPasswordFormContext.Provider>
  );
}

export function useShouldShowPasswordForm() {
  return useContext(shouldShowPasswordFormContext);
}

export function useSetShouldShowPasswordForm() {
  return useContext(setShouldShowPasswordFormContext);
}
